export const config = {
  supportedCountries: [
    'nl',
    'gb',
    'fr',
    'de',
    'se',
    'dk',
    'fi',
    'no',
    'mx',
    'es',
    'it',
    'br',
    'sv-fi',
  ],
  countryAliasMap: {
    ax: 'sv-fi',
    ie: 'gb',
  },
}
